import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";

import { IFileUpload } from "../../../features/FileUpload/components/FileUpload.type";
import { getUniqueId } from "../../../helpers";
import { uploadMultipleFile } from "../../../features/FileUpload/utils";
import { makeApiCall } from "../../../helpers/postRequest";
import { IPaymentBulkAccountsRecievable } from "./PaymentBulkAccountsRecievable.types";


export const addAccountingPaymentBulkAccountsRecievableAsync =
  (
    data: IPaymentBulkAccountsRecievable,
    initialData: IPaymentBulkAccountsRecievable,
    isUpdate: boolean,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const asPayload = {
        invoice_id: data.invoice_id,
      };
      const { paths } = await uploadMultipleFile(
        data.file_upload || [],
        "ACCOUNTING",
        asPayload
      );

      await makeApiCall(
        {
          url: "/accounting/edit-account-payment-accounts-receivable",
          method: "POST",
          automation: {
            isUpdate: isUpdate,
            primaryFieldName: "invoice_id",
          },
        },
        initialData,
        {
          ...data,
          file_upload: paths,
        }
      );

      const message = "Payment Accounts Recievable saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

  export const FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_PROGRESS =
  "FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_PROGRESS";
export const FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_SUCCESS =
  "FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_SUCCESS";
export const FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_FAILURE =
  "FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_FAILURE";

export const fetchAccountingPaymentBulkAccountsRecievableProgress = () =>
  action(FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_PROGRESS);

export const fetchAccountingPaymentBulkAccountsRecievableSuccess = (
  data: IPaymentBulkAccountsRecievable
) => action(FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_SUCCESS, { data });

export const fetchAccountingPaymentBulkAccountsRecievableFailed = (
  errorMessage: string
) =>
  action(FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_FAILURE, {
    errorMessage,
  });

export const fetchAccountingPaymentBulkAccountsRecievableAsync =
  (paymentId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingPaymentBulkAccountsRecievableProgress());
      const res = await api.get(
        `/accounting/get-account-payment-accounts-receivable?payment_id=${paymentId}`
      );
      const data: IPaymentBulkAccountsRecievable[] = res.data.data;
      if (data.length > 0) {
        const attachments: IFileUpload[] = [];
        for (const item of (data[0].file_upload || []) as any) {
          attachments.push({
            file: null,
            key: getUniqueId(),
            path: item,
          });
        }
        dispatch(
          fetchAccountingPaymentBulkAccountsRecievableSuccess({
            ...data[0],
            file_upload: attachments,
          })
        );
      }
    } catch (err: any) {
      dispatch(
        fetchAccountingPaymentBulkAccountsRecievableFailed(
          "Something went to be wrong!"
        )
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };